const defaultBackground = {
  image: null,
  repeat: 'no-repeat',
  position: 'top left',
  attachment: 'scroll',
  size: 'auto',
}

const getPortfolioStyles = (data) => {
  const backgroundData = { ...defaultBackground, ...(data?.background || {}) }
  const image = backgroundData?.image
  let background = backgroundData?.color || ''

  if (image?.src) {
    background = `${background} url('${image?.src}') ${backgroundData?.repeat} ${backgroundData?.attachment} ${backgroundData?.position}`
  }

  const styles = {
    background,
    backgroundSize: backgroundData?.size,
  }

  if (backgroundData?.color && image?.src) {
    styles.backgroundBlendMode = 'overlay'
  }

  return styles
}

export default getPortfolioStyles
